// src/auth.js
import { supabase } from './supabaseConfig';

export const signInWithGoogle = async () => {
  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        queryParams: {
          access_type: 'offline',
          prompt: 'consent',
        },
      },
    });
    
    if (error) throw error;
    return data.user;
  } catch (error) {
    console.error('Error during Google sign in:', error);
    throw error;
  }
};

export const logout = async () => {
  try {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  } catch (error) {
    console.error('Error during logout:', error);
    throw error;
  }
};

export const requireAuth = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return !!session;
};
